module.exports = __webpack_public_path__ + "img/gcdp_7.a4c71feb.jpg";